<t-llevo-dialog-header
  [dialogTitle]="dialogTitle()"
  mat-dialog-title
></t-llevo-dialog-header>
<mat-dialog-content>
  <form
    commonui-loader
    [appLoader]="loading() ?? false"
    [formGroup]="frm"
    class="formGroup"
  >
    <mat-form-field>
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" #firstInput />
      @if (name.hasError('required')) {
        <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Capacidad</mat-label>
      <input matInput formControlName="passengers" type="number" />
      @if (passengers.hasError('required')) {
        <mat-error>Campo requerido</mat-error>
      } @else if (passengers.hasError('min')) {
        <mat-error>La capacidad debe ser superior a 0</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Tipo de Combustible</mat-label>
      <mat-select formControlName="energySource">
        @for (option of energySources; track option.value) {
          <mat-option value="{{ option.value }}">{{ option.label }}</mat-option>
        }
      </mat-select>
      @if (energySource.hasError('required')) {
        <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-checkbox formControlName="available" class="py-1">Habilitado</mat-checkbox>

    <t-llevo-image-input
      formControlName="photo"
      [aspectRatio]="16 / 9"
    ></t-llevo-image-input>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="loading() ?? false"
    color="accent"
  >
    {{submitBtn()}}
  </button>
</mat-dialog-actions>
